import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import { Station } from '@paragon/contract-library';

import { PartsFilterSelection } from './getMemberFilter';

interface PartsFilterProps {
  readonly partsFilterSelection: PartsFilterSelection;
  readonly setPartsFilterSelection: (partsFilterSelection: PartsFilterSelection) => void;
}

export function PartsFilter({ partsFilterSelection, setPartsFilterSelection }: PartsFilterProps) {
  return (
    <ToggleButtonGroup
      value={partsFilterSelection}
      exclusive
      onChange={(_, value) => {
        if (value != null) setPartsFilterSelection(value);
      }}
    >
      <ToggleButton value="allMembers">All</ToggleButton>
      <ToggleButton value="chords">Chords</ToggleButton>
      <ToggleButton value="webs">Webs</ToggleButton>
      <ToggleButton value="blocks">Blocks</ToggleButton>
      <ToggleButton value="other">Other</ToggleButton>
      <ToggleButton value="plates">Plates</ToggleButton>
    </ToggleButtonGroup>
  );
}

export function getDefaultPartsFilterSelection(station: Station | null): PartsFilterSelection {
  if (station === null) return 'allMembers';
  switch (station.role) {
    case 'ChordSaw':
      return 'chords';
    case 'WebSaw':
      return 'webs';
    case 'BlockSaw':
      return 'blocks';
    case 'PlatePull':
      return 'plates';
    default:
      return 'allMembers';
  }
}
